// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"12b48ab8","977":"c05c3c01"}[chunkId] + ".chunk.js";
};